import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import image1 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي ثوم.jpg";
import image2 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي جزر.jpg";
import image3 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي خيار.jpg";
import image4 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي فلفل أحمر.jpg";
import image5 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي فلفل هاليبينو.jpg";
import image6 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي لوز.jpg";
import image7 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي ليمون.jpg";

import contact from "../Images/Group-of-customer-service-representatives.jpg";

export default function ProductStuffedSpain() {
  const [currID, setCurrID] = useState("");
  const [loading, setLoading] = useState(false);
  const [productName, setProductName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  async function sendQuote(e) {
    e.preventDefault();
    setLoading(true);
    axios
      .post(
        `https://mrolive-back-end-2c3o.onrender.com/api/v1/quote`,
        {
          name: name,
          email: email,
          productName: productName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        toast.success(response?.data?.msg);
        setName("");
        setEmail("");
        document.getElementById("name").value = "";
        document.getElementById("email").value = "";
      })
      .catch((e) => {
        toast.error(e?.data?.msg);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  let imgList = Array.from(document.getElementsByClassName("imgItem"));
  let lightContainer = document.querySelector(".lightContainer");
  let lightBox = document.querySelector(".lightBox");
  let currentIndex = 0;
  // console.log(lightContainer);

  function showImage(x) {
    document
      .querySelector(".lightContainer2")
      .classList.replace("d-none", "d-flex");
    // console.log("ayhagaaasa")
    document.querySelector(".very").style.backgroundImage = `url(${x.src})`;
    document.querySelector(".productName").innerHTML = x.name;
    currentIndex = x.id;
    // console.log(currentIndex)
    setCurrID(currentIndex);
  }

  function closeSlide() {
    document
      .querySelector(".lightContainer2")
      .classList.replace("d-flex", "d-none");
  }
  function showForm() {
    document
      .querySelector(".showForm")
      .classList.replace("d-none", "d-inline-block");
  }

  return (
    <>
      <ToastContainer />

      <div className="products " onClick={closeSlide}></div>
      <div className="container p-4">
        <div className="row p-3">
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="1"
                src={image1}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Aceituna verde rellena de ajo");
                }}
                alt="image not found"
                className="photo"
                name="Aceituna verde rellena de ajo"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Aceituna verde rellena de ajo
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="2"
                src={image2}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Aceituna verde rellena de zanahoria");
                }}
                alt="image not found"
                className="photo"
                name="Aceituna verde rellena de zanahoria"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Aceituna verde rellena de zanahoria
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="3"
                src={image3}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Aceituna verde rellena de pepinillo");
                }}
                alt="image not found"
                className="photo"
                name="Aceituna verde rellena de pepinillo"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Aceituna verde rellena de pepinillo
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="4"
                src={image4}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Aceituna verde rellena de pimiento rojo");
                }}
                alt="image not found"
                className="photo"
                name="Aceituna verde rellena de pimiento rojo"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Aceituna verde rellena de pimiento rojo
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="5"
                src={image5}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Aceituna verde rellena de jalapeño verde");
                }}
                alt="image not found"
                className="photo"
                name="Aceituna verde rellena de jalapeño verde"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Aceituna verde rellena de jalapeño verde
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="6"
                src={image6}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Aceituna verde rellena de almendra");
                }}
                alt="image not found"
                className="photo"
                name="Aceituna verde rellena de almendra"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Aceituna verde rellena de almendra
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="7"
                src={image7}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Aceituna verde rellena de limón");
                }}
                alt="image not found"
                className="photo"
                name="Aceituna verde rellena de limón"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Aceituna verde rellena de limón
            </p>
          </div>
        </div>
      </div>
      <div className="lightContainer2 d-none  align-items-center">
        <div className="lightBox2  ">
          <div className="container">
            <div className="row d-flex justify-content-center ">
              <div className="ayhaga" style={{ marginTop: "30px" }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img className=" very" alt="" style={{ padding: "0" }} />
                </div>
                <h4
                  className="productName"
                  style={{
                    color: "#4e732c",
                    display: "flex",
                    justifyContent: "center",
                  }}
                ></h4>

                <div>
                  <p style={{ color: "white" }}>
                    {" "}
                    Nuestra fábrica rellena aceitunas verdes a mano de acuerdo
                    con las especificaciones y normas internacionales Sus tipos
                    son los siguientes:
                    <br />
                    1. Aceituna verde rellena de zanahoria
                    <br />
                    2. Aceituna verde rellena de pimiento rojo
                    <br />
                    3. Aceituna verde rellena de jalapeño verde
                    <br />
                    4. Aceituna verde rellena de ajo
                    <br />
                    5. Aceituna verde rellena de almendra
                    <br />
                    6. Aceituna verde rellena de limón
                    <br />
                    7. Aceituna verde rellena de pepinillo{" "}
                  </p>
                  <div>
                    {" "}
                    <table class="  table-bordered ">
                      <thead>
                        <tr>
                          <th>Descripción del artículo</th>
                          <th>Tamaño (Normas griegas)</th>
                          <th>Trozos de aceitunas/KG (Estándar español)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th rowSpan="10">Aceitunas verdes rellenas</th>
                          <td> Atlas </td>
                          <td>70-90</td>
                        </tr>
                        <tr>
                          <td> Súper Mamut</td>
                          <td> 91-100</td>
                        </tr>
                        <tr>
                          <td> Mamut</td>
                          <td>101-110</td>
                        </tr>
                        <tr>
                          <td> Súper colosal</td>
                          <td>111-120</td>
                        </tr>
                        <tr>
                          <td>colosal</td>
                          <td>121-141</td>
                        </tr>
                        <tr>
                          <td> Gigantes</td>
                          <td> 141-160</td>
                        </tr>
                        <tr>
                          <td>Extra Jumbo</td>
                          <td>161-180</td>
                        </tr>
                        <tr>
                          <td>Jumbo</td>
                          <td> 181-200</td>
                        </tr>
                        <tr>
                          <td>Extra Grande</td>
                          <td> 201-230</td>
                        </tr>
                        <tr>
                          <td>Grande </td>
                          <td> 231-260</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px",
                  }}
                >
                  <button
                    className="btn get bgDark"
                    style={{ marginBottom: "5px" }}
                    onClick={showForm}
                  >
                    Obtener cotización
                  </button>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <form onSubmit={sendQuote}>
                    <div className="showForm d-none ">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Introduzca su nombre"
                        style={{ marginBottom: "5px" }}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                      />
                      <input
                        type="email"
                        className="form-control"
                        // id="exampleFormControlInput2"
                        id="email"
                        placeholder="Introduce tu correo electrónico"
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "10px",
                        }}
                      >
                        <button
                          className="btn get"
                          style={{ marginTop: "5px" }}
                          type="submit"
                        >
                          {loading ? (
                            <i className="fa-solid fa-spinner fa-spin"></i>
                          ) : (
                            "Enviar"
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <i
            style={{
              color: "black",
              backgroundColor: "white",
              padding: "10px",
              borderRadius: "10px",
            }}
            id="close"
            className="fa-solid fa-xmark"
            onClick={closeSlide}
          ></i>
        </div>
      </div>
      <div
        className="row"
        style={{
          backgroundColor: "#4e732c",
          color: "white",
          margin: "0",
          display: "flex",
          justifyContent: "end",
        }}
      >
        <div className="col-md-7 col-sm-8" style={{ marginTop: "25px" }}>
          <div className="container">
            <div className="row ">
              <div
                className="col-md-12"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div className="contactContect">
                  <h6> contáctenos</h6>

                  <p>cuando tienes una pregunta estamos aquí para ayudarte</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-1 col-sm-4"
          style={{ backgroundColor: "#4e732c" }}
        ></div>
        <div className="col-md-4 col-sm-12 " style={{ padding: "0" }}>
          <img src={contact} alt="" className="contactMeFooter" />
        </div>
      </div>
    </>
  );
}
